import React, { useState } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import './Dashboard.css';
import Overview from '../Overview/Overview';
import Analyzer from '../Analyzer/Analyzer';
import Converter from '../Converter/Converter';
import Settings from '../Settings/Settings';
import Users from '../Users/Users';

function Dashboard({ onLogout }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const menuItems = [
    { path: '/', label: 'Overview', icon: '▣' },
    { path: '/analyzer', label: 'Analyzer', icon: '◈' },
    { path: '/converter', label: 'Converter', icon: '⟲' },
    { path: '/settings', label: 'Settings', icon: '⚙' },
    { path: '/users', label: 'Users', icon: '⚉' },
  ];

  const handleNavigation = (path) => {
    navigate(path);
  };

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="dashboard-container">
      <aside className={`sidebar ${isSidebarOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-header">
          <h2>ANTARES</h2>
          <button
            className="toggle-sidebar"
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          >
            {isSidebarOpen ? '◀' : '▶'}
          </button>
        </div>
        <nav className="sidebar-nav">
          {menuItems.map((item) => (
            <button
              key={item.path}
              className={`nav-item ${isActive(item.path) ? 'active' : ''}`}
              onClick={() => handleNavigation(item.path)}
            >
              <span className="nav-icon">{item.icon}</span>
              {isSidebarOpen && <span className="nav-label">{item.label}</span>}
            </button>
          ))}
        </nav>
        <div className="sidebar-footer">
          <button className="logout-button" onClick={onLogout}>
            <span className="nav-icon">↪</span>
            {isSidebarOpen && <span>Logout</span>}
          </button>
        </div>
      </aside>
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Overview />} />
          <Route path="/analyzer/*" element={<Analyzer />} />
          <Route path="/converter/*" element={<Converter />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/users" element={<Users />} />
        </Routes>
      </main>
    </div>
  );
}

export default Dashboard;
